/**
 * useAuth Hook
 * Auto-generated - Auth Tokens Infrastructure Component
 *
 * Provides authentication state and actions.
 * Must be used within an AuthProvider.
 *
 * Usage:
 *   const { user, isAuthenticated, isLoading, login, logout, refreshToken } = useAuth();
 */
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthProvider";

export interface AuthContextValue {
  user: Record<string, unknown> | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  refreshToken: () => Promise<boolean>;
}

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
